/**
 * The amount of events that needed to be collected before sending them to the server
 *
 * @see https://zattoo2.atlassian.net/wiki/spaces/webapp/pages/3515973637/Product+Analytics+Events#Transmission
 * @type {number}
 */
export const LOG_EVENT_THRESHOLD = 10;
/**
 * Maximum waiting time between logs.
 */
export const LOG_INTERVAL_MS = 30 * 1000; // 30 seconds
export const REPORTING_PROTOCOL_VERSION = 1;
